'use client';

import { useEffect } from 'react';
import logExploreTrailCardListActionTaken from '@alltrails/amplitude/events/logExploreTrailCardListActionTaken';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import Sidebar from '@alltrails/maps/components/Sidebar/Sidebar';
import MobileResultsList from '@/components/MobileResultsList/MobileResultsList';
import { sidebarId } from '@/utils/constants';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import { setIsMobileListAtTop, setIsShowingMobileList, setPanelCollapsed } from '@/utils/slices/exploreSlice';

export default function SidebarSlot({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobileSizedScreen();
  const dispatch = useAppDispatch();
  const { isShowingMobileList, panelCollapsed } = useAppSelector(state => ({
    isShowingMobileList: state.explore.isShowingMobileList,
    panelCollapsed: state.explore.panelCollapsed
  }));

  useEffect(() => {
    // It is very confusing if resizing the screen shows the mobile list because as the screen continues to shrink, the list results change for seemingly no reason
    if (isMobile) {
      dispatch(setIsShowingMobileList(false));
    }
  }, [dispatch, isMobile]);

  useEffect(() => {
    if (!isShowingMobileList) {
      // Reset when the list is hidden so that when the list is shown again, we recognize that its at the top once again.
      dispatch(setIsMobileListAtTop(true));
    }
  }, [dispatch, isShowingMobileList]);

  return isMobile ? (
    <>{isShowingMobileList && <MobileResultsList>{children}</MobileResultsList>}</>
  ) : (
    <Sidebar
      collapsed={panelCollapsed}
      id={sidebarId}
      onCollapseRequest={() => {
        if (panelCollapsed) {
          logExploreTrailCardListActionTaken({ action_taken: 'window toggled open' });
          dispatch(setPanelCollapsed(false));
        } else {
          logExploreTrailCardListActionTaken({ action_taken: 'window toggled closed' });
          dispatch(setPanelCollapsed(true));
        }
      }}
    >
      {children}
    </Sidebar>
  );
}
